import styled from '@emotion/styled/macro';

export const Wrapper = styled.div`
    display: flex;
    width: 100%;
    height: 36px;
    min-height: 36px;
    background-color: ${props => props.theme.colours.skybet.blue};
    justify-content: center;
    align-items: center;
`;

export const CrossSellLink = styled.a`
    display: flex;
    background-color: ${props => props.theme.colours.skybet.blue};
    font-size: 16px;
    font-family: ${props => props.theme.fonts.regular};
    justify-content: center;
    align-items: center;
    text-decoration: none;
    color: white;
`;

export const CrossSellImg = styled.img`
    display: block;
    height: 15px;
    border-radius: 1.2px;
    margin-left: 4px;
`;
